import { firstNameSchema, lastNameSchema } from '@massilia/features'
import { validatePhoneNumber } from '@massilia/queries'
import { z } from 'zod'

// Lookup schema: matches against EXISTING stored bookings — do not apply the
// strict name rules, otherwise legacy names with accents couldn't be found.
export const depositLookupSchema = z.object({
  email: z.string().min(1, 'Ce champ est requis').email('Veuillez saisir une adresse email valide'),
  lastName: z.string().min(1, 'Ce champ est requis'),
  dossierNumber: z.string().min(1, 'Ce champ est requis'),
})

export type DepositLookupSchema = z.infer<typeof depositLookupSchema>

export const legacyDepositSchema = z.object({
  email: z.string().min(1, 'Ce champ est requis').email('Veuillez saisir une adresse email valide'),
  firstName: firstNameSchema,
  lastName: lastNameSchema,
  amountEuros: z.number().min(0.01, 'Veuillez saisir un montant valide'),
  comment: z.string().optional(),
  dossierNumber: z.string().min(1, 'Ce champ est requis'),
  phone: z
    .string()
    .min(1, 'Ce champ est requis')
    .refine((value) => validatePhoneNumber(value) === undefined, {
      message: 'Numéro de téléphone invalide',
    }),
})

export type LegacyDepositSchema = z.infer<typeof legacyDepositSchema>
